import React, { useState, useEffect, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import styles from './product-row.scss';
import Image, { AddVideoDiv } from '../../common/product-image/ImageViewUpload';
import MoreMenu from 'jd-library/MoreMenu';
import withRipple from 'jd-library/withRipple';
import Button from 'jd-library/Button';
import AddEditButton from './AddEditButton';
import { toggleProductVisibility,deleteProduct, productUnderEdit, updateApprovalPending, updateDeletionPending, matchLowestPrice, updateProductStatus, getListingData, setRedirectedFrom, objectionableTakeLive, updateGenericDeletionPending, updateBrand, updateAuditPending, updateRejectedProducts, toggleProdConflict, showItemSearchSlider, updateViaSuggested, updateSuggestedViaSearch, clickTrack, getPsvDetails } from '../../actions/products';
import { fetchDataAndEdit } from '../../actions/items';
import { showHideLoader } from '../../actions/index';
import toastMessageActions from "jd-library/toastMessageActions";
//import { showToastMessage } from '../../actions/toastmessage';
import SearchText from '../../common/SearchText';
import { useHistory } from 'react-router-dom'
import ProductRowVendor from './ProductRowVendor';
import { getAddImageDivCount } from '../../common/productImageUtils';
import AuthWrapper from '../../common/AuthWrapper';
import axios from 'axios';
import { checkLoggedIn, getMatchedUOM, getAuditProductUrl, identifyAuditFlow, getAuditTagValues} from '../../utills';
import {useLocation} from "react-router-dom";
import {getProductData,setSelectedType,updateEditProductDetail} from '../../actions/products'
import CommissionModal from './CommissionModal';
import LowestPriceModal from './LowestPriceModal';
import Modal from 'jd-library/Modal';
import BifurcateModel from './BifurcateModel';
import historyHandler from 'jd-library/historyHandler';
import { updateBrandManufactureDetails } from '../../actions/productSpecification';
import ProductStatus from './ProductStatus';
import ProductScore from './ProductScore';
import ProductData from '../product-inventory/product-data/ProductData';
import { toggleFeedbackForm } from '../../common/Feature/FeedbackSlider/redux/action';
import { SwipeableDrawer } from 'jd-library';

const ProductRow = props => {
	const productData = props.productData;
	const profileObject = props.session?.profileObject
	const isAddProduct = props.productId == 'ADD_PRODUCT';
	const stopPropogation = event => {
		event && event.stopPropagation();
	};
	const history = useHistory();
	const [animateClass, updateClass] = useState('');
	const [modalOpen, setModal] = useState(false);
	const [editedByJdEmp, setEditedByJdEmp] = useState(false);
	const [commissionModal, showCommissionModal] = useState(false);
	const [lowestPriceModal, showLowestPriceModal] = useState(false);
	const [bifurcateModel, showBifurcateModel] = useState(false);
	const [reverseAnimate, updateReverse] = useState(false);
	const priceObj = productData.priceObj || {};
	const isAuditObjectionable = productData?.id && productData?.objectionableContent ? true : false;
	const aa=(props.tabKey && props.tabKey!="omniService" && (props[props.tabKey + 'List']?.indexOf(props.productId) != -1 || (props.tabKey=='auditPending' && isAuditObjectionable && props.objectionalAuditPendingList?.indexOf(productData.id)!=-1)));
	const bb=(props.tabKey == 'brand' && props.brandSelDesel.list[props.productId] && props.brandSelDesel.list[props.productId].active) 
	const cc=(props['deletionPendingList'].indexOf(props.productId) != -1)
	const tickStatus = props.tabKey != 'auditPending' && props.tabKey != 'rejected' && props.tabKey != 'documentPending'  && aa || bb || cc;
	const objectionalTab = (props.tabKey == 'auditPending' && productData.id && !props.isAuditor )
	const templateProduct = productData.generic_p_id || false;
	const deleteTemplateProduct = productData.isDeleteAllowed;
	const brandedTab = (!props.fromSelectProductSlider && (props.tabKey == 'brand' || props?.searchTab == 'brand'));
    const conflicTab = props.tabKey == 'productConflict' && !props.fromSelectProductSlider && !props.searchText;
	const dispatch = useDispatch();
	const creCheck = identifyAuditFlow({query: true});
	const contractorTypes = ["CONTRACTOR", "CONTRACTORV2","CONTRACTORV3"];
	const isContractor = props.session.user.loggedUser && (contractorTypes.indexOf(props.session.user.loggedUser.subType) != -1);
	const isContractorV1 = props?.session?.user?.loggedUser?.subType && (["CONTRACTOR"].indexOf(props?.session?.user?.loggedUser?.subType) != -1)
	const [showApproveProductButtonLoader, setShowApproveProductButtonLoader] = useState(false)
	const [isProductScorePopUpOpen, setIsProductScorePopUpOpen] = useState(false)
	const [viaOmni, setViaOmni] = useState(props?.session?.viaOmni || false);
	const isCorrector =  props.session.user.loggedUser?.subType == 'CORRECTOR'	

	const renderSellingPrice = () => {
		if (priceObj && priceObj.isSinglePrice) {
			if (priceObj.singlePrice && ['0', '0.0', '0.00'].indexOf(priceObj.singlePrice.toString()) === -1) {
				return true
			} else {
				return false;
			}
		} else if (priceObj && !priceObj.isSinglePrice) {
			if ((priceObj.minPrice && ['0', '0.0', '0.00'].indexOf(priceObj.minPrice.toString()) === -1) && priceObj.maxPrice && ['0', '0.0', '0.00'].indexOf(priceObj.maxPrice.toString()) === -1) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
		// if (
		// 	//productData.sellingPrice &&
		// 	//['0', '0.0', '0.00'].indexOf(productData.sellingPrice) === -1
		// ) {
		// 	return true;
		// } else {
		// 	return false;
		// }
	};
	const openEditModal = e => {
		//console.log(e);
		e ? setModal(true) : setModal(false);
		if (!e) {
			handleRelease();
		}
	};
	const isSellingPrice = renderSellingPrice();
	const renderUom = () => {
		if (productData.uom && !brandedTab && ((productData.isSellOnline && productData.sellingPrice) || isSellingPrice || Number(productData?.priceObj?.singlePrice))) {
				return (
					<span className={styles['uom']}>
						{`/ ${getUom((productData.uom), !['pieces','packet','pairs','units'].includes(productData.uom))}`}
					</span>
				);
		} else {
			return null;
		}
	};
	const editProduct = (prod) => {
		if( objectionalTab && viaOmni){
			return
		}
		if (!props.isFromActionCard && (conflicTab || props.objectionableMode || (brandedTab && ((!productData.active && props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER') || (props.session.user.loggedUser && props.session.user.loggedUser.userType != 'OWNER'))))) {
			return;
		}
		if (props.onProductClick) {
			props.onProductClick(productData);
			return;
		}
		if(!profileObject.isRE && !profileObject.isSO && profileObject.isSer){
			props.setSelectedType({ selectedCategoryType: 'service' });
		}
		if (props.session.source == "webstore") {
			if (productData.variantStatus) {
				props.toggleNoEditModal(true);
				return;
			}
			// ProductIframeCommunication.editProductInCMS({
			// 	appType: 'customerApp',
			// 	pageType: 'edit',
			// 	productId: productData.productId,
			// 	variantId: productData.variantId,
			// 	productType: productData.templatingType,
			// 	clickOn: 'proddesc',
			// 	module: productData.type == 'SERVICE' ? 'service' : 'product',
			// 	page: 'listing',
			// 	event: null,
			// 	productCB: window.productCB,
			// 	href: '' //this.detailsPageUrl
			// });
			props.fetchDataAndEdit({
				itemId: productData.productId,
				token: props.session.token,
				cb: () => {
					if (props.session.source == "b2b") {
						history.push(`/edit-item/${productData.productId}`);
					} else {
						let params = `?source=${window.location.pathname}`;
						if (props.searchText) {
							params += `&query=${props.searchText}`;
						}
						props.setRedirectedFrom({ redirectedFrom: 'listing' });
						history.push(`/edit-item/${productData.productId}${params}`);
						props.setRedirectedFrom({ redirectedFrom: 'listing' });
						// window.location.replace(`/myaccount/vendor/edit-item/${productData.productId}${params}`);
					}
				}
			});
			return;
		}
		setTimeout(() => {
			if (!props.deviceData.isMobile && !props.isDummyProductRow){
				dispatch(showHideLoader({showLoader:true}));
			}
			if (props.deviceData.isMobile) {
				let url = ''
				if(props.session.viaOmni){
					if(isAddProduct){
						url=`/products/add-omni/?selectedProductType=${prod}`
					} else{
						const pid=productData?.generic_p_id || productData?.productId || props?.productId
						if((objectionalTab || productData.saveObjectionable == 'true') && !props.searchText){
							url=`/products/edit-omni/${pid}?isObjection=true`;
						}else {
							url=`/products/edit-omni/${pid}`;
						}
					}
				}
				else if (isAddProduct) {
					url = '/products/add?selectedProductType=' + prod;
				} else {
					if (objectionalTab && !props.searchText) {
						url = `/products/edit/${productData.productId}?isObjection=true`;
					} else if (!props.isFromActionCard && brandedTab) {
						url = `/products/edit/${props.productId}?isBrandedProd=true`;
					} else if (productData.generic_p_id) {
						url = `/products/edit/${productData.generic_p_id}?isGenericProduct=true`;
					} else {
						url = '/products/edit/' + props.productId ;
					}
				}
				history.push(url);
			} else {
				let productId = props.productId || '';
				if (productData.generic_p_id) {
					productId = productData.generic_p_id;
				}
				let obj = {
					productId,
					id: productData.id ? productData.id : '',
					isObjectionable: !props.isFromActionCard && productData.id && !props.searchText ? true : false,
					isBrandedProd: !props.isFromActionCard && brandedTab ? true : false,
					isTemplateProduct: productData.generic_p_id ? true : false,
					cb : () => {
						dispatch(showHideLoader({showLoader:false}));
					}
				}
				props.getProductData({
					...obj
				})
			}
			openEditModal(false);
		}, 400);
	};
	const duplicateProduct = () => {
		dispatch(clickTrack({ll: "digital_catalog",li: "duplicate",userBasedCheck: true}))
		if (props.deviceData.isMobile) {
			const addUrlPrefix=props.session.viaOmni?"/products/add-omni/":"/products/add/"
			history.push(addUrlPrefix + props.productId);
		} else {
			props.getProductData({
				productId: props.productId || '',
				isDuplicate: true
			})
		}
		openEditModal(false);
	}

	const hideProduct = () =>{
		if(!productData.visibility) {
			updateReverse(true);
			setTimeout(() => {
				props.toggleProductVisibility({
					productId: productData.productId,
					pidList: productData.pidList,
					hiddenVariantCount: productData.hiddenVariantCount,
					visibility: !productData.visibility,
					token:props.session.token,
					status: productData.reviewStatus
				});
				updateReverse(false);
				props.showToastMessage({
					showToastMessage: true,
					message: (productData.type == 'service' ? 'Service' : 'Product')+' Status Updated',
					duration: 1000,
					type: 'info'
				})
			}, 300);

		} else {
			props.toggleProductVisibility({
				productId: productData.productId,
				pidList: productData.pidList,
				hiddenVariantCount: productData.hiddenVariantCount,
				visibility: !productData.visibility,
				token:props.session.token,
				status: productData.reviewStatus
			});
			props.showToastMessage({
				showToastMessage: true,
				message: (productData.type == 'service' ? 'Service' : 'Product')+' Status Updated',
				duration: 1000,
				type: 'info'
			})
		}
	}
	const brandActivateDeactivateProduct = (type) => {
		props.toggleActivateDeactivateModal({
			productData: productData,
			action: type
		});
	}
	//Is Gallery Product check
	const isGalleryProd = productData.productName && productData.productName.indexOf('GPB2BMARKETPLACE') > -1;
	const isGalleryProdHidden = isGalleryProd && props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE';

	let list = [];
	let isObjection = false;

	const selectFromLibrary =()=>{
        props.toggleProdConflict({conflictProdKey: productData.barcodeConflictId});
    }

	if (productData && productData.auditStatusFlag == "objectionable product") {
		isObjection = true;
	}
	const templateProductClick = () => {
		if (props.session.showCompanyDetails) {
			checkLoggedIn({
				cb: editProduct,
				history
			});
		} else {
			editProduct();
		}
	};
	if (props.isAuditor) {
		list = [
			{
				label: 'Delete',
				icon: !props.deviceData.isMobile ? 'icon-trash' : '',
				imgUrl: props.deviceData.isMobile ? 'https://akam.cdn.jdmagicbox.com/images/icontent/dc_module/delete-icn.svg' : '',
				onClick: event => {
					stopPropogation(event);
					openEditModal(false);
					props.confirmDelete(productData)
				}
			}
		]
	} else if (objectionalTab || (props.tabKey == 'auditPending' && productData.id)) {
		if ((props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER')) {
			list = [
				{
					label: 'Edit',
					hide: viaOmni,
					icon: !props.deviceData.isMobile ? 'icon-editItem' : '',
					imgUrl: props.deviceData.isMobile ? 'https://akam.cdn.jdmagicbox.com/images/icontent/dc_module/edit-icn.svg' : '',
					onClick: () => {
						if (props.session.showCompanyDetails) {
							checkLoggedIn({
								cb: editProduct,
								history
							});
						} else {
							editProduct();
						}
					}
				},
				{
					label: 'Delete',
					hide: ((props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE')),
					icon: !props.deviceData.isMobile ? 'icon-trash' : '',
					imgUrl: props.deviceData.isMobile ? 'https://akam.cdn.jdmagicbox.com/images/icontent/dc_module/delete-icn.svg' : '',
					onClick: event => {
						stopPropogation(event);
						if (props.session.showCompanyDetails) {
							checkLoggedIn({
								cb: () => {
									openEditModal(false);
									props.confirmDelete(productData);
								},
								history
							});
						} else {
							openEditModal(false);
							props.confirmDelete(productData);
						}
					}
				}
			];
		} else {
			list = [
				{
					label: 'Edit',
					icon: !props.deviceData.isMobile ? 'icon-editItem' : '',
					imgUrl: props.deviceData.isMobile ? 'https://akam.cdn.jdmagicbox.com/images/icontent/dc_module/edit-icn.svg' : '',
					onClick: () => {
						if (props.session.showCompanyDetails) {
							checkLoggedIn({
								cb: editProduct,
								history
							});
						} else {
							editProduct();
						}
					}
				}
			];
		}
	} else if (brandedTab) {
		if (props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER' && productData.active) {
			list.push({
				label: 'Edit',
				icon: !props.deviceData.isMobile ? 'icon-editItem' : '',
				imgUrl: props.deviceData.isMobile ? 'https://akam.cdn.jdmagicbox.com/images/icontent/dc_module/edit-icn.svg' : '',
				onClick: () => {
					if (props.session.showCompanyDetails) {
						checkLoggedIn({
							cb: editProduct,
							history
						});
					} else {
						editProduct();
					}
				}
			})
		}
		if (!productData.active) {
			list.push({
				label: 'Activate',
				onClick: (event) => {
					if (props.session.showCompanyDetails) {
						checkLoggedIn({
							cb: () => {
								stopPropogation(event);
								brandActivateDeactivateProduct("activate");
							},
							history
						});
					} else {
						brandActivateDeactivateProduct("activate");
					}
				}
			})
		} else {
			list.push({
				label: 'Deactivate',
				onClick: (event) => {
					if (props.session.showCompanyDetails) {
						checkLoggedIn({
							cb: () => {
								stopPropogation(event);
								brandActivateDeactivateProduct("deactivate");
							},
							history
						});
					} else {
						brandActivateDeactivateProduct("deactivate");
					}
				}
			})
		}
	} else if (templateProduct) {
		list = [{
			label: 'Edit',
			icon: !props.deviceData.isMobile ? 'icon-editItem' : '',
			imgUrl: props.deviceData.isMobile ? 'https://akam.cdn.jdmagicbox.com/images/icontent/dc_module/edit-icn.svg' : '',
			onClick: templateProductClick
		}];
		if (deleteTemplateProduct) {
			list.push({
				label: 'Delete',
				icon: !props.deviceData.isMobile ? 'icon-trash' : '',
				imgUrl: props.deviceData.isMobile ? 'https://akam.cdn.jdmagicbox.com/images/icontent/dc_module/delete-icn.svg' : '',
				onClick: (event) => {
					stopPropogation(event);
					if (props.session.showCompanyDetails) {
						checkLoggedIn({
							cb: () => {
								openEditModal(false);
								productData.cb = () => {
									props.deleteProduct(null, null, null, {
										generic_p_id: props.productData.generic_p_id
									});
									setTimeout(() => {
										dispatch(toastMessageActions.showMessage({
											message: (productData.type == 'service' ? 'Service' : 'Product') + ' Deleted Successfully',
											showReduxToast: true,
											animationTime: 5000
										}))
										props.updateDeletionPending({ deletionPendingList: [] });
										props.updateGenericDeletionPending({ genericDeletionList: [] });
									}, 300);
								};
								props.confirmDelete(productData);
							},
							history
						});
					} else {
						openEditModal(false);
						productData.cb = () => {
							props.deleteProduct(null, null, null, {
								generic_p_id: props.productData.generic_p_id
							});
							setTimeout(() => {
								dispatch(toastMessageActions.showMessage({
									message: (productData.type == 'service' ? 'Service' : 'Product') + ' Deleted Successfully',
									showReduxToast: true,
									animationTime: 5000
								}))
								props.updateDeletionPending({ deletionPendingList: [] });
								props.updateGenericDeletionPending({ genericDeletionList: [] });
							}, 300);
						};
						props.confirmDelete(productData);
					}
				}
			});
		}
	} else {
		list = [
			{
				label: 'Edit',
				icon: !props.deviceData.isMobile ? 'icon-editItem' : '',
				imgUrl: props.deviceData.isMobile ? 'https://akam.cdn.jdmagicbox.com/images/icontent/dc_module/edit-icn.svg' : '',
				hide: objectionalTab && viaOmni,
				onClick: () => {
					if (props.session.showCompanyDetails) {
						checkLoggedIn({
							cb: editProduct,
							history
						});
					} else {
						editProduct();
					}
				}
			},
			{
				label: 'Delete',
				icon: !props.deviceData.isMobile ? 'icon-trash' : '',
				imgUrl: props.deviceData.isMobile ? 'https://akam.cdn.jdmagicbox.com/images/icontent/dc_module/delete-icn.svg' : '',
				hide: ((props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE') && (productData.reviewStatus == 'DELETION_PENDING' || productData.isJdEditable === false) ||  ([1,3].includes(Number(props.session?.newProfile)) && props.session.userSource ==='14'&& props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE')  ),
				onClick: event => {
					if (props.session.showCompanyDetails) {
						checkLoggedIn({
							cb: () => {
								stopPropogation(event);
								openEditModal(false);
								props.confirmDelete(productData);
								// props.deleteProduct(props.variantId);
								// props.showToastMessage({
								// 	showToastMessage: true,
								// 	message: 'Product Deleted - ' + productData.productName,
								// 	duration: 5000
								// });
							},
							history
						});
					} else if (props.session.source != 'webstore') { // not genio and webstore
						stopPropogation(event);
						openEditModal(false);
						props.confirmDelete(productData);
					} else {
						stopPropogation(event);
						openEditModal(false);
						props.deleteProduct(props.productId);
					}
				}
			},
			{
				label: 'Duplicate',
				hide: viaOmni || (productData.isTemplate || (productData.reviewStatus?.toString().split(',').includes('REJECTED') || productData.reviewStatus?.toString().split(',').includes('DOCUMENT_PENDING')) || (props.session.user.loggedUser && ((props.session.user.loggedUser.userType == 'OWNER' && (productData.reviewStatus == 'APPROVAL_PENDING' || productData.reviewStatus == 'DELETION_PENDING')) || (props.session.user.loggedUser.userType == 'JDEMPLOYEE' && productData.reviewStatus == 'DELETION_PENDING'))) || isGalleryProd),
				icon: !props.deviceData.isMobile ? 'icon-customPage' : '',
				imgUrl: props.deviceData.isMobile ? 'https://akam.cdn.jdmagicbox.com/images/icontent/dc_module/duplicate-icn.svg' : '',
				onClick: () => {
					if (props.session.showCompanyDetails) {
						checkLoggedIn({
							cb: duplicateProduct,
							history
						});
					} else {
						duplicateProduct();
					}
				}
			}
			
		];
	}

	if(!props.tabKey || viaOmni)
	{
		list.push({
			label: !productData.visibility || props.productData.hiddenVariantCount > 0? 'Unhide':'Hide',
			hide: (objectionalTab || props.tabKey=='objectionable') && viaOmni,
			icon: !props.deviceData.isMobile ? 'icon-glhide' : '',
			imgUrl: props.deviceData.isMobile ? 'https://akam.cdn.jdmagicbox.com/images/icontent/dc_module/hide-icn.svg' : '',
			onClick: () => {
				let checkAndHide = () => {
					if(productData.variantCount > 1){
						props.updateModalData({
							show: true,
							action: !productData.visibility || props.productData.hiddenVariantCount > 0? 'unhide':'hide',
							onHideUnhide: hideProduct,
							isService: productData.type == 'service'
						})
					}else {
						hideProduct();
					}
				}
				if (props.session.showCompanyDetails) {
					checkLoggedIn({
						cb: checkAndHide,
						history
					});
				} else {
					if(productData.variantCount > 1){
						checkAndHide();
					}else {
						hideProduct();
					}
				}
			}
		})
	}

	list = list.filter(cur => !cur?.hide)

	const openPriceModal = event => {
		if (isAddProduct || isGalleryProd || productData.priceObj?.priceOnQty?.length > 0 || ['stds'].includes(productData.uomType)) {
			return;
		}
		const PsvDetailsUomType = props.getPsvDetails(productData)	
		
		stopPropogation(event);
		let uom = '', uomType = '';
		if (
			productData.uom
		) {
			uom = getUom(productData.uom, true)
			uomType = getMatchedUOM(props.uom, productData.uom)
		}
		// let productUnderEdit = {
		// 	productName: productData.productName,
		// 	sellingPrice: productData.sellingPrice,
		// 	productId: productData.productId,
		// 	isSellingPrice: isSellingPrice,
		// 	uom: uom,
		// 	uomType: uomType.uomType
		// };
		
		// props.productUnderEdit({ productUnderEdit: productUnderEdit });
		/* props.openPriceModal(productUnderEdit); */
		props.openPriceModal({
			...props.productData,
			isSellingPrice,
			uom: uom,
			uomType: uomType,
			PsvDetailsUomType : PsvDetailsUomType?.UNIT || []
		});
	};

	const getUom = (uom, forceSingular, getUomType) => {
		//for visit and session new introduce(val)
		if (/\s/g.test(uom)){
			let myString = uom.replace(/[^a-zA-Z]/g,'');
			let myNum = uom.match(/\d/g,'');
			let res = ""
			myNum && myNum.map(d => {
				res += d
			})
			myNum = res
			if (["Sess","Visit"].includes(myString)){
					if (myString ==  'Sess'){
					myString = 'Session'
					console.log('`${myNum} ${myString}`',`${myNum} ${myString}`);
					if (myNum == 1) {
						return `${myString}`
					}else {
						return `${myNum} ${myString}s`
					}
				}else if (myString ==  'Visit'){
					myString = 'Visit'
					if (myNum == 1) {
						return `${myString}`
					}else {
						return `${myNum} ${myString}s`
					}
				}
			}
		}
		let uomType = props?.productData?.uomType || '';
		let uomObj = props?.uomJsonMap?.[uom];
		// for specific time duration
		//on reciving join 1 Sess, 1 Visit...
		if(!uomObj && uomType.trim()=='stds' && typeof(uom) === 'string' && new RegExp(/[\d+]/).test(uom)){
			if (/\s/.test(uom)){
				const hasNumbers = uom.match(/\d+/);
				let myString = uom.replace(/[^a-zA-Z]/g,'');
				if(hasNumbers && hasNumbers[0] === '1'){
					let getLastCh = (myString[myString.length -1 ] == 's') ?  myString.slice(0, -1) : myString
					return getLastCh.charAt(0).toUpperCase() + getLastCh.slice(1);
				} else {
					return  `${hasNumbers} ${myString.charAt(0).toUpperCase() + myString.slice(1)}`
				}
			} else {
				return uom
			}		
		}
		if (getUomType && uomObj) {
			return uomObj.uomType;
		}
		if (forceSingular) {
			return uomObj ? uomObj.singular : uom;
		}
		if (productData.minOrderQuantity == 1) {
			return uomObj ? uomObj.singular : uom;
		} else {
			return uomObj ? uomObj.plural : uom;
		}
	};

	//Approve pending status
	// let showCheckBox = (props.tabKey == 'approvalPending' || props.tabKey == 'deletionPending') && (props.session.user.loggedUser && props.session.user.loggedUser.userType == "OWNER");
	const isReadOnlyProduct = props.readOnlyProduct || props.session.isReadOnly;
	let showCheckBox = (isReadOnlyProduct || props.isAuditor || objectionalTab || conflicTab) ? false : (props.session.source == "b2b" && !isAddProduct && !props.searchText && !(props.session.user.loggedUser && props.session.user.loggedUser.userType == "JDEMPLOYEE" && props.tabKey));
	if (props.session.source == "b2b" && ['brand','rejected'].includes(props.tabKey)) {
		showCheckBox = false;
	}
	let showColourLoaderIfEmpty = props.isAuditor ? false : !(props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER') && (productData.reviewStatus == 'APPROVAL_PENDING' || productData.reviewStatus == 'DELETION_PENDING' || productData.reviewStatus == 'AUDIT_PENDING' || (productData.reviewStatus?.toString().split(',').includes('REJECTED') || productData.reviewStatus?.toString().split(',').includes('DOCUMENT_PENDING'))) || (!((profileObject.isSO && !profileObject.isRE && !profileObject.isSer) && props.session.userSource ==='14') && props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE');

	showColourLoaderIfEmpty=showColourLoaderIfEmpty || !((props.session.user.loggedUser && ["OWNER"].includes(props.session.user.loggedUser.userType) && (productData.imageUrl=="" || !productData?.imageUrlArr?.length)) || props.session.user.loggedUser && ["OWNER","JDEMPLOYEE"].includes(props.session.user.loggedUser.userType) && !productData?.productId);

	if(props.productId == 'ADD_PRODUCT'){
		showColourLoaderIfEmpty=false
	}

	const disableFileSelectionTooltip=showColourLoaderIfEmpty || !productData?.productId;

	let shouldRedirectToEditInsteadOfOption=false || !productData?.productId;


	let showEditBtn = !isReadOnlyProduct;
	let hideForStatus = ['auditPending','deletionPending','approvalPending','brand','rejected'].includes(props.tabKey) || ['APPROVAL_PENDING','DELETION_PENDING','AUDIT_PENDING'].includes(productData.reviewStatus)
	if ((!isAddProduct && !isGalleryProd && props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER' && productData.reviewStatus != 'REVIEWED') || (brandedTab && props.session.user.loggedUser && props.session.user.loggedUser.userType != 'OWNER') || (hideForStatus || productData.isSellOnline)) {
		showEditBtn = false;
	}
	if (props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER' && !(hideForStatus || productData.isSellOnline)) {
		showEditBtn = true;
	}
	if ((!props.session.user.loggedUser && (props.tabKey == 'approvalPending' || props.tabKey == 'deletionPending')) || (props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE' && props.isSpecialContractJd)) {
		showCheckBox = false;
	}
	let idForDeletion = props.productId;
	if (props.session.source == 'webstore' && !props.searchText && !props.readOnlyProduct) {
		showCheckBox = true;
		idForDeletion = productData.productId
	}
	if(productData.type == "service" && productData.variant_flag == 1){
		showEditBtn = false
	}
	showCheckBox =  (
		props.tabKey == 'documentPending' ||
		(viaOmni && 
			(
				objectionalTab || 
				(['auditPending','objectionable'].includes(props.tabKey)  && productData.id)
			)	
		)
	) ? false : showCheckBox;
	
	const updateList = (productId, isRemove, isTemplateProduct) => {
				
		if (isAuditObjectionable) {
			productId = productData.id;
		} else if (props.session.source == 'webstore' && !props.objectionableMode) {
			productId = productData.productId;
		} 
		
		let tabKey = props.tabKey || 'deletionPending';
		if(props.tabKey=="omniService"){
			tabKey='deletionPending'
		}
		let tempList = tabKey == 'approvalPending' ? [...props.approvalPendingList] : tabKey == 'auditPending' ? isAuditObjectionable ? [...props.objectionalAuditPendingList] : [...props.auditPendingList] : tabKey == 'rejected' ? [...props.rejectedList] : [...props.deletionPendingList];
		const isBrandTab = tabKey == 'brand';
		let tempGenericList = [...props.genericDeletionList];
		if (isBrandTab) {
			tempList = { ...props.brandSelDesel };
			if (tempList.list[props.productId]) {
				delete tempList.list[props.productId];
			} else {
				tempList.list[props.productId] = {
					active: true
				};
			}
		} else {			
			const pIds = productData?.variant_flag && tabKey != 'approvalPending' ? productData.pidList.split(',') : [productId];
			let vidInd = -1, nVid=0;
			pIds.map((vid, ind) => {
				nVid = Number(vid);
				vidInd = tempList.indexOf(nVid);
				if (vidInd != -1 || isRemove) {
					tempList.splice(vidInd, 1);
					if (isTemplateProduct || tabKey=="omniService") {
						tempGenericList.splice(tempGenericList.indexOf(nVid), 1);
					}						
				} else {
					if (vidInd === -1) {
						tempList.push(nVid)
						if (isTemplateProduct || tabKey=="omniService") {
							tempGenericList.push(vid);
						}
					}
				}
						
			});			
		}
		let data = {};
		if (tabKey == 'auditPending' && isAuditObjectionable) {
			data['objectionalAuditPendingList'] = tempList;
		} else {
			data[tabKey + 'List'] = tempList;	
		}
				
		if (tabKey == 'approvalPending') {
			props.updateApprovalPending(data);
		} else if (tabKey == 'deletionPending') {
			props.updateDeletionPending(data);
		} else if (tabKey == 'brand') {
			props.updateBrand(data);
		} else if (tabKey == 'auditPending') {
			props.updateAuditPending(data);
		} else if(tabKey == 'rejected'){
			props.updateRejectedProducts(data);
		}
		if (isTemplateProduct) {
			props.updateGenericDeletionPending({ genericDeletionList: tempGenericList });
		}
	}

	const checkForCommission = (e) => {
		if(!showApproveProductButtonLoader) {
			if (productData.commissionPerc) {
				showCommissionModal(true)
			} else {
				approveSingleProduct(e);
			}
		}
	}

	const approveSingleProduct = (e) => {
		e.stopPropagation();

		if(showApproveProductButtonLoader) return
		setShowApproveProductButtonLoader(true)

		let params = { tabKey: props.tabKey };
		if (props.pageType == 'search') {
			params.isSearch = true;
			params.searchText = props.searchText;
		}
		props.updateProductStatus({
			token: props.session.token,
			productId: productData.pidList|| productData.productId,
			cb: (isLastProductApproved = false,res = {}) => {
				updateList(productData.productId, true);
				props.getListingData({...params,cb: () => {setShowApproveProductButtonLoader(false)}});
				dispatch(toastMessageActions.showMessage({
					message: `${productData.type == 'service' ? 'Service' : 'Product'}  Approved -  ${productData.productName}`,
					showReduxToast: true,
					animationTime: 5000
				}));
				if(res.objectionableCount){
					props.updateObjectionModal({
						show: true,
						apiData: res,
						isLastProductApproved,
						cb: (isLastProductApproved = false) => {
							if(props.session?.user?.loggedUser?.userType == 'OWNER' && isLastProductApproved)
								dispatch(toggleFeedbackForm({show:true,options: {isObjectionable: true}}));
						}
					})
				}
				if(props.session?.user?.loggedUser?.userType == 'OWNER' && isLastProductApproved && !res.objectionableCount) {
					dispatch(toggleFeedbackForm({show:true}));
				}
			}
		})
	}

	const matchSellingPrice = (e) =>{
		let params = { tabKey: props.tabKey };
		if (props.pageType == 'search') {
			params.isSearch = true;
			params.searchText = props.searchText;
		}
		props.matchLowestPrice({
			productId: productData.productId,
			price: productData.lowestPrice.toString()?.replaceAll(',',''),
			cb: () => {
				updateList(productData.productId, true);
				props.getListingData(params);
				dispatch(toastMessageActions.showMessage({
					message: 'Selling Price Updated Successfully',
					showToastMessage: true,
					type: 'info',
					duration: 5000
				}));
			}
		})
	}
	const handleCloseModal =()=>{
        showLowestPriceModal(false);
    }
	const onConfirmDelete=()=>{
        showLowestPriceModal(false);
        matchSellingPrice();
	}

	const deleteCb = (isDelete = true) => {
		let params = { tabKey: props.tabKey };
		if (props.pageType == 'search') {
			params.isSearch = true;
			params.searchText = props.searchText;
		}
		dispatch(showHideLoader({showLoader:true}));
		props.updateProductStatus({
			action: 'delete',
			isDelete: isDelete,
			token: props.session.token,
			productId: productData.productId,
			cb: () => {
				updateList(productData.productId, true);
				props.getListingData(params);
				dispatch(showHideLoader({showLoader:false}));
				if (isDelete) {
					dispatch(toastMessageActions.showMessage({
						message: (productData.type == 'service' ? 'Service' : 'Product') + ' Deleted Successfully',
						showReduxToast: true,
						animationTime: 5000,
						type: 'info'
					}));
				}
			}
		})
	}

	const deleteSingleProduct = (e, isDelete) => {
		e.stopPropagation();
		if (isDelete) {
			let data = { ...productData };
			data.cb = deleteCb;
			props.confirmDelete(data);
		} else {
			deleteCb(false);
		}
	}

	useEffect(() => {
		if (props.isProductUpdated && !props.objectionableMode) {
			updateClass('add-bg-color');
			setTimeout(() => {
				updateClass('')
			}, 2000)
		}
	}, [props.productData])
	useEffect(() => {
		if (props.isProductUpdated) {
			if (props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE') {
				if (!props.showAddEditProduct && !props.imageSliderVisible && !props.showLibrarySlider) {
					setTimeout(() => {
						// #TO_DO Impossible! Code to remove
						props.getListingData({ tabKey: props.tabKey });
					}, 1500);
				}
			}
		}
	}, [props.isProductUpdated])

	useEffect(() => {
		if (productData.reviewStatus == 'APPROVAL_PENDING') {
			setEditedByJdEmp(true);
		} else {
			setEditedByJdEmp(false);
		}
	}, [productData.reviewStatus])

	let mediaUrlArr = [...(productData.imageUrlArr || []), ...(productData.videoUrlArr || [])];
	let noPrimaryImage = false;
	if (!(productData.imageUrlArr && productData.imageUrlArr.length) && productData.videoUrlArr.length) {
		//video cannot be primary
		mediaUrlArr.unshift({
			uploaded: false
		})
		noPrimaryImage = true;
	}
	if(props.tabKey === "brand" && mediaUrlArr.length){
		mediaUrlArr[0].imgURL = mediaUrlArr[0]?.imgURL?.split('|~|')[0];
		mediaUrlArr[0].actualPath = mediaUrlArr[0]?.actualPath?.split('|~|')[0];
	}
	let location = useLocation();
	const productOnclick = (prod, from) => {
		if (from == 'bifurcate' || isAddProduct) {
			(!props.deviceData.isMobile && from) && historyHandler.closeCurrent();
			if( prod != 'service' && (prod == 'product' || !(!profileObject.isRE && !profileObject.isSO && profileObject.isSer))){
				if(props.deviceData.isMobile){
					setTimeout(() => {
						history.push('/products/itemsearch')
					}) ;
				}
				else{
					props.showItemSearchSlider();
				}
				return;
			}
		}
		if (props.objectionableMode || (objectionalTab && viaOmni)) {
			return;
		}
		let flowCheck = identifyAuditFlow({ checkType: true });
		let searchObj = identifyAuditFlow({ query: true });
		if (flowCheck.searchAudit || flowCheck.isSpecialContract) {
			getAuditProductUrl({
				productId: props.productData.productId,
				searchBy: (isObjection ? "objectionableId" : ""),
				id: (isObjection ? productData.id : ""),
				cb: (data) => {
					if (data.data.status) {
						let productId = props.productId;
						if (window.top != window.self) {
							data.data.url += '&loadedInIframe=true';
						}
						// if(!searchObj.fromFetchFlow) {
						data.data.url += "&useAuditApi=true";
						// }
						if (flowCheck.isSpecialContract) {
							data.data.url += "&isSpecialContract=true";
						}
						if (isObjection) {
							data.data.url += "&isObjection=true";
						}
						if (productData.generic_p_id) {
							data.data.url += "&isGenericProduct=true";
							productId = productData.generic_p_id;
						}
						if (data.data.url.indexOf(props.session.basePath) != -1) {
							let finalUrl;
							if (isObjection) {
								finalUrl = data.data.url.split(props.session.basePath)[1];
							} else {
								let url = data.data.url.split("?")[1];
								const urlPrefix=props.session.viaOmni?"/products/edit-omni/":"/products/edit/"
								finalUrl = `${urlPrefix}${productId}?${url}`;
							}
							history.push(finalUrl);
						} else {
							window.location.href = data.data.url;
						}
					}
				}
			});
		} else if (props.session.showCompanyDetails && !isReadOnlyProduct) {
			checkLoggedIn({ cb: () => editProduct(prod), history });
		} else {
			editProduct(prod);
		}
	}
	let showCatSelectionPending = false && (productData.categoryPresent == 0 && !isGalleryProd && props.tabKey != 'brand');
	if ((productData.reviewStatus == 'DELETION_PENDING' && props.session.source != 'webstore') || objectionalTab || brandedTab) {
		showCatSelectionPending = false;
	}
	let auditStatusIcon = '';
	let auditStatusTag = '';
	let auditStatusText = '';
	if (productData && productData.auditStatusFlag) {
		let flag = productData.auditStatusFlag.toLowerCase();
		if (flag == 'correction not required'){
			auditStatusIcon = 'icon-Checkmark';
			auditStatusTag = 'grey';
			auditStatusText = 'CORRECTION NOT REQUIRED';
		}else if (flag == 'correction pending'){
			auditStatusIcon = 'icon-alertNew';
			auditStatusTag = 'red';
			auditStatusText = "CORRECTION PENDING";
		}else if (flag == 'corrected'){
			auditStatusIcon = 'icon-Checkmark';
			auditStatusTag = 'green';
			auditStatusText = 'CORRECTED';
		}else if (flag == 'audit pending') {
			auditStatusIcon = 'icon-alertNew';
			auditStatusTag = 'red';
			auditStatusText = "AUDIT PENDING";
		} else if (flag == 'audit not required') {
			auditStatusIcon = 'icon-Checkmark';
			auditStatusTag = 'grey';
			auditStatusText = 'AUDIT NOT REQUIRED';
		} else if (flag == 'audited - vendor approval pending') {
			auditStatusIcon = 'icon-alertNew';
			auditStatusTag = 'yellow';
			auditStatusText = 'AUDITED - VENDOR APPROVAL PENDING';
		} else if (flag == 'audited - sampled') {
			auditStatusIcon = 'icon-Checkmark';
			auditStatusTag = 'green';
			auditStatusText = 'AUDITED - SAMPLED';
		} else if (flag == "objectionable product") {
			// auditStatusIcon = 'icon-alertNew'; #366863 As discussed with shaminder
			// auditStatusTag = 'red';
			// auditStatusText = "OBJECTIONABLE PRODUCT";
		} else if(flag == 'rejected'){
			auditStatusIcon = 'icon-alertNew';
			auditStatusTag = 'red';
			auditStatusText = 'REJECTED';
		}else {
			auditStatusIcon = 'icon-Checkmark';
			auditStatusTag = 'green';
			auditStatusText = 'AUDITED';
		}
	}

	let productTag = '';
	let tagColor = '';
	if ((productData && productData.queueType) || (brandedTab && !productData.active)) {
		let tagValues = {};
		if (brandedTab) {
			tagValues = getAuditTagValues({
				type: 'brand'
			});
		} else {
			tagValues = getAuditTagValues({
				type: productData.queueType
			});
		}
		productTag = tagValues.productTag;
		tagColor = tagValues.tagColor;
	}

	//Long press functionality
	let clickTimer;
	const handlePress = () => {
		if (props.session.source == 'webstore' && !props.searchText) {
			clickTimer = setTimeout(() => {
				updateList(props.productId)
			}, 1000)
		}
	}

	const handleRelease = () => {
		if (props.session.source == 'webstore' && !props.searchText) {
			clearTimeout(clickTimer);
		}
	}

	const objectionableProductImage = props.objectionableMode ? {
		imageUrl: props.objectionableProducts.find(product => product.id == props.productId).imageUrl,
		imageUrlArr: undefined,
		customCB: () => {
			return;
		}
	} : {}

	let customOnClick;
	if (templateProduct) {
		customOnClick = templateProductClick;
	} else if (isAddProduct && !props.session.showCompanyDetails && !props.isDummyProductRow)   {
		customOnClick = editProduct;
	}
	let showProductCheckBox = showCheckBox && !props.objectionableMode && !templateProduct &&!(props.session.newProfile=='1' &&props.session.userSource ==='14'&& props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE');
	if (templateProduct) {
		showProductCheckBox = deleteTemplateProduct;
	}
	const openAddEditSlider = productId => {
		axios.get('/vendorapis/products/product/fetchTemplateProductById',{
			params: {
				productId: productId,
				token: props.session.token,
				viaSuggested: 1,
				newProfile:props.session?.newProfile
			}
		}).then(res => {
			let data = res.data.data[0];
			if(!res.data.data?.length) {
				console.log("res : ",res.data);
				console.log("API : fetchTemplateProductById ,data is Empty , token: ",props.session.token);
				console.log("SupId : ",props.session.supplierId)
				console.log("DocId : ",props.session.docId)
			}
			if (data.productExist && data.type != "SERVICE") {
				props.updateBrandManufactureDetails({
					detailsSpecification: data.detailsSpecification
				})
				if (props.deviceData.isMobile) {
				  const urlPrefix=props.session.viaOmni?"/products/edit-omni/":"/products/edit/"
				  if(urlPrefix.includes("/products/edit/")){
					history.push(urlPrefix+ data.productId);
				  }else {
					  history.push(urlPrefix+"/products/edit/" + data.productId);
				  }
				  dispatch(updateViaSuggested({viaSuggested: true}));
				  dispatch(updateSuggestedViaSearch({viaSearch:props.pageType == 'search'}));
				  return;
				}
				props.getProductData({
				  productId: data.productId,
				  id: data.id,
				  viaSuggested: true
				});
				dispatch(updateSuggestedViaSearch({viaSearch:props.pageType == 'search'}));
				return;
			}
			let dataArr = [];
			let complianceCount = 0;
			data && Object.keys(data).map((cur,index) => {
				dataArr.push({
					key: cur,
					value: data[cur]
				})
			})
			data.compliance && Object.keys(data.compliance).map(cur => {
                if(!['hsn','tax_rate','importer','importers_detail','country_of_origin','manufacturer','manufactured_details','price','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date','brand'].includes(cur.toLowerCase()) && !data.compliance[cur]){
                  complianceCount ++;
                }
              })
			let imgUrlArr = data.productImages?data.productImages.map((cur) => {
                return {
                  finalImageSrc: cur,
                  imgURL: cur,
                };
              }):[];
			  console.log(data.SalesTax)
              dataArr = dataArr.concat([
                {
                  key: "productId",
                  value: "ADD_PRODUCT",
                },
                {
                  key: "parentId",
                  value: data.id,
                },
                {
                  key: "isTempProd",
                  value: ((props.tabKey == 'brand' || props.searchTab == 'brand') && (props.productData.type == 'service' || data.type == 'SERVICE') ) 
				  	|| ((props.productData.type == 'product' || data?.type == 'PRODUCT') && data?.generic_product)  ? false : true,
                },
                {
                  key: "imageUrlArr",
                  value: imgUrlArr,
                },
				{
					key: 'hasCompliance',
					value: complianceCount
				},
                {
                  key: "bizSuggestion",
                  value: {
                    data: [						
                      	{ 
						  bizType: data.businessType, 
						  natCatId: data.businessType 
						}
                    ],
                    selected: data.businessType ? 1 : 0,
					bizType: data.businessType,
                  },
                },
                // {
                //   key: "toggleBiz",
                //   value: data?.businessType?.length ? false : true,
                // },
                {
                  key: "sellingOnlinePrice",
                  value: '',//data.sellingPrice && Number(data.sellingPrice?.toString()?.replaceAll(',','')) > 0 ? data.sellingPrice : "",
                },
				{
					key : 'salesTaxJson',
					value: data.SalesTax? JSON.parse(data.SalesTax):""
				  },
				  {
					key: 'salesTax',
					value: data.SalesTax? JSON.parse(data.SalesTax):""
				  },
				  {
					key: 'hsnPresent',
					value: data.hsnSacNo
				  },
				  {
					key: 'taxPresent',
					value: data.SalesTax && String(JSON.parse(data.SalesTax)?.gstRate)?.trim().length ? data.SalesTax : '',
				  },
				  {
					key: 'isManufacturerMand',
					value: Number(data.compliance_flag?.manufacturer_flag)
				  },
				  {
					key: 'mrp',
					value: ''
				  },{
					key: 'detailsSpecification',
					value: data.detailsSpecification
				  },{
					key: 'categoryType',
					value: data.productType?.toLowerCase()
				  }
				  
              ]);
			  if((props.productData.type == 'product' || data?.type == 'PRODUCT') && data?.generic_product) {
				dataArr = dataArr.filter(cur => cur.key != 'hasCompliance')
			  }
			  props.updateEditProductDetail(dataArr);
			  props.setSelectedType({
				selectedCategoryType: data.productType?.toLowerCase()
			});
			  props.updateBrandManufactureDetails({
				detailsSpecification: data.detailsSpecification
				})
			  setTimeout(() => {
				//   props.getProductData({
				// 	variantId: "ADD_PRODUCT",
				//   });
				props.getProductData({
					productId: 'ADD_PRODUCT',
					isTemp: true,
					viaSuggested: true
				})
				dispatch(updateSuggestedViaSearch({viaSearch:props.pageType == 'search'}));
			});
              if (props.deviceData.isMobile) {
				const addUrlPrefix=props.session.viaOmni?"/products/add-omni":"/products/add"
				history.push(addUrlPrefix+"?isTemp=true");
					dispatch(updateSuggestedViaSearch({viaSearch:props.pageType == 'search'}));
                return;
              }
			console.log(res.data);
		})
	}

	const isPopUpOpenFunc = (status) => {
		setIsProductScorePopUpOpen(status)
	}

	const getBtnLabel = (type) => {
		const profileType = props?.productData?.type;
		if (type == "specMissingCount") {
			return "Add Specifications"
		} else if (type == "descMissingCount") {
			return "Add Description"
		} else if (type == "rejectedCount" || type == "scoreLessThanHundred") {
			return `Update ${profileType[0].toUpperCase()+profileType.slice(1)}`
		} else {
			return "Add"
		}
	}

	const isShowProductScore =
		(!props.tabKey || (viaOmni && props.tabKey=="omniService")) &&
		productData.productId &&
		!productData.isSellOnline &&
		(props.isTemplateProd ||
		((props.isAuditor && typeof productData.productScore !== 'undefined' && productData.productScore != null) 
		|| (typeof productData.finalWeight !== 'undefined' && productData.finalWeight != null)));

	const allPriceObj = { ...productData.priceObj, sellingPrice: productData.sellingPrice }

	return (
		<>
			<div className={`${isProductScorePopUpOpen ? "productScore-visible" : ""} ${styles['prod-block']} ${props.isAuditor ? 'auditor-prod-row' : ''} ${tickStatus ? styles['check-tint'] : ''} ${isAddProduct ? styles['add-prod-block'] : ''} ${animateClass} ${props.rippleClass} ${modalOpen ? styles['show-moremenu'] : ''} ${props.session.source == 'webstore' ? 'webstore' : 'b2b'} ${!showEditBtn ? styles['under-review'] : ''} ${(props['deletionPendingList'].indexOf(idForDeletion) != -1 || props['approvalPendingList'].indexOf(idForDeletion) != -1) ? 'checked' : ''} ${isGalleryProd ? styles['gallery-prod'] : ''} ${isGalleryProdHidden ? styles['gallery-prod-hide'] : ''}`} onClick={() => isAddProduct && [2,4].includes(Number(props.session?.newProfile)) ? showBifurcateModel(true) : (brandedTab && !props.isFromActionCard) ?  checkLoggedIn({ cb: () => { openAddEditSlider(productData.productId) }}) : (!profileObject.isRE && !profileObject.isSO && profileObject.isSer) && !props.isAuditor ? editProduct('service') : productOnclick()}
			onTouchStart={handlePress} onTouchEnd={handleRelease} onTouchMove={handleRelease}
			tabIndex={0}
			onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
			{...props.rippleHandler}>
				{props.renderRipple && props.renderRipple()}
				<div onClick={stopPropogation}>
					<Image
						{...props}
						{...productData}

						uploadLabel={"Add Photo"}
						showAddImageWithText
						showCheckBox={props.isActionCardSliderOpen ? false : showProductCheckBox}
						redirectToEdit={(props.session.showCompanyDetails && !isReadOnlyProduct) ? () => checkLoggedIn({ cb: (Number(props.session?.newProfile) == 3 || productData.type == 'service') ? editProduct('service') : isAddProduct && (Number(props.session?.newProfile) == 2 || Number(props.session?.newProfile) == 4) ? showBifurcateModel(true) : editProduct, history }) : Number(props.session?.newProfile) == 3 || productData.type == 'service' ? () => editProduct('service') : isAddProduct && (Number(props.session?.newProfile) == 2 || Number(props.session?.newProfile) == 4) ? () => showBifurcateModel(true) : editProduct}
						tickStatus={props.tabKey != 'documentPending' && ((props.tabKey == 'brand' && tickStatus) || (props.tabKey && props.tabKey!="omniService" && props[props.tabKey + 'List']?.indexOf(idForDeletion) != -1) || (isAuditObjectionable && props.tabKey == 'auditPending' && props['objectionalAuditPendingList']?.indexOf(productData?.id) != -1) || (props['deletionPendingList'].indexOf(idForDeletion) != -1))}
						showColourLoaderIfEmpty={showColourLoaderIfEmpty || props.objectionableMode}
						disableFileSelector={disableFileSelectionTooltip}
						shouldRedirectToEditInsteadOfOption={shouldRedirectToEditInsteadOfOption}
						checkCB={() => { updateList(props.productId, false, templateProduct) }}
						imageUrlArr={!props.isDummyProductRow && mediaUrlArr}
						isReadOnly={((props.isFromActionCard && (props.slidertype != 'imgMissingCoun' || props.actionCardFilterType != 'imgMissingCoun')) || !props.isFromActionCard) &&  (props.productData.showUpload === 0 || objectionalTab || props.objectionableMode || brandedTab || conflicTab)}
						isObjectionable={objectionalTab}
						templateProduct={templateProduct}
						onlyForSelection={props.isFromActionCard || (props.session.newProfile == '1' && creCheck.source === "14" && props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE')}
						isBrandedProd={brandedTab}
						customOnClick={customOnClick}
						isGalleryProd={isGalleryProd}
						pos='bottom'
						fromListing={true}
						{...objectionableProductImage}
					/>
					{(props.isAuditor || isGalleryProd || props.onlyForSelection || objectionalTab || brandedTab || templateProduct || conflicTab) ? null : <ProductRowImageList
					{...props}
					{...productData}
					creCheck={creCheck}
					isTemplate={productData.isTemplate ? productData.isTemplate : (props.session.newProfile == '1' && props.session.userSource ==='14'&& props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE') }
					redirectToEdit={(props.session.showCompanyDetails && !isReadOnlyProduct) ? () => checkLoggedIn({ cb: productData.type == 'service' ? editProduct('service') : editProduct, history }) : productData.type == 'service' ? () => editProduct('service') : editProduct}
					mediaUrlArr={mediaUrlArr}
					noPrimaryImage={noPrimaryImage}
				/>}
				</div>
				{props.session.source == 'webstore' ? (
					<ProductRowVendor
						{...props}
						onEditToggle={openEditModal}
						getUom={getUom}
						toggleNoEditModal={props.toggleNoEditModal}
						toggleModal={props.toggleModal}
						getModalObj={props.getModalObj}
						searchText={props.searchText}
						confirmDelete={props.confirmDelete}
					/>
				) : (
					<>
						<div className={styles['prod-desc']+' '+(props.deviceData.isMobile?'mob':'')}>
							{props.searchText ? (
								<SearchText
									search={props?.searchText}
									text={productData?.productName}
									className={"prod-title font-16"}
								/>
							) : (
								isAddProduct ? (
									<div
										className={styles['prod-name-shim']}
									/>
								) : (
									<div className={styles['prod-name-wrapper']}>
										<p className={`prod-title ${props.deviceData.isMobile ? 'font-16' : 'font-18'} ${(props.isAuditor && !productData.sellingPrice) ? 'auditor-bottom-unset' : ''}`}>
											{productData.productName}
										</p>
										{!props.isFromActionCard && props.productData.attachmentPresent ?
											<span className='icon-Gl_Attachment'></span> : null}
									</div>
								)
							)}
							{isAddProduct ? (
								<div
									className={styles['prod-price-shim']}
								/>
							) : null}
							{templateProduct && (<div className={`${styles['template-tag']} ${!props.deviceData.isMobile ? styles['web'] : ''} ${props.pageType == 'search' ? styles["search"] : ''}`}>
								<div className={styles['info-holder']}>
									<i className={'icon-Info'}></i>
								</div>
								<div className={styles['template-text']}>
									Product added based on your category in Justdial
								</div>
							</div>)}
							{!templateProduct ? (
							<>
							{!props.isFromActionCard &&
							<div className={styles['price']}>
								{!conflicTab && !brandedTab && ((isSellingPrice && priceObj.isSinglePrice && Number(priceObj.singlePrice)) || (productData.isSellOnline && productData.sellingPrice)) ?
									<span className={styles['product-price']}>
										<span className={'font-16'}>
											<span className={`${styles['currency']} icon-currency`}></span>
											{' ' +
												(((props.isAuditor || productData.isSellOnline) && productData.sellingPrice) ? Number(productData.sellingPrice).toLocaleString() : Number(
													priceObj.singlePrice
												).toLocaleString('en-IN'))}
										</span>
									</span>
									:
									isSellingPrice && Number(
										priceObj.minPrice
									) && Number(
										priceObj.maxPrice
									) ?
										<>
											<span className={styles['product-price']}>
												<span className={'font-16'}>
													<span className={`${styles['currency']} icon-currency`}></span>
													{' ' +
														Number(
															priceObj.minPrice
														).toLocaleString('en-IN') + '  '}
												</span>
											</span>

											<span>-</span>
											<span className={styles['product-price']}>
												<span className={'font-16'}>
													<span className={`${styles['currency']} icon-currency`} style={{ marginLeft: '3px' }}></span>
													{' ' +
														Number(
															priceObj.maxPrice
														).toLocaleString('en-IN')}
												</span>
											</span>
										</>
										:
										priceObj.priceOnQty && priceObj.priceOnQty.length > 0 &&
										<>
											<span className={styles['product-price']}>
												<span className={'font-16'}>
													<span className={`${styles['currency']} icon-currency`}></span>
													{' ' +
														Number(
															priceObj.priceOnQty[priceObj.priceOnQty.length - 1].price
														).toLocaleString('en-IN') + '  '}
												</span>
											</span>
											<span>-</span>
											<span className={styles['product-price']}>
												<span className={'font-16'}>
													<span className={`${styles['currency']} icon-currency`} style={{ marginLeft: '3px' }}></span>
													{' ' +
														Number(
															priceObj.singlePrice
														).toLocaleString('en-IN')}
												</span>
											</span>
										</>
								}
								{(props.isAuditor) && ((productData.isSellOnline && productData.sellingPrice) || isSellingPrice || Number(productData?.priceObj?.singlePrice)) ? (<span className={'auditorUOM'}>{ `/  ${getUom(productData.uom, !(/\d/.test(productData.uom)),'')}`} </span>) : renderUom()}
								{(props.isAuditor || isReadOnlyProduct || objectionalTab || (viaOmni && productData?.productId)) ? null : ((!props.searchText || props.deviceData.isMobile) && <span onMouseDown={event => event.stopPropagation()}>
									<AuthWrapper>
										{showEditBtn  ? (
											<AddEditButton
												isEdit={productData.isSellOnline || (productData.priceObj?.priceOnQty?.length > 0) ? true : isAddProduct ? false : isSellingPrice}
												onClick={openPriceModal}
												customText={isAddProduct || isGalleryProd ? "ADD DESCRIPTION" : ""}
											/>
										) : null}
									</AuthWrapper>
								</span>)}
							</div>}
							{(props.isAuditor || isReadOnlyProduct || objectionalTab || (viaOmni && productData?.productId)) ? null : ((props.searchText && !props.deviceData.isMobile) && <span onMouseDown={event => event.stopPropagation()}>
								<AuthWrapper>
									{showEditBtn ? (
										<div className="edit-btn-container">
											<AddEditButton
												isEdit={productData.isSellOnline || (productData.priceObj?.priceOnQty?.length > 0) ? true : isAddProduct ? false : isSellingPrice}
												onClick={openPriceModal}
												customText={isAddProduct || isGalleryProd ? "ADD DESCRIPTION" : ""}
											/>
										</div>
									) : null}
								</AuthWrapper>
							</span>)}
							{!props.isFromActionCard && !isContractorV1 &&
								productData.isSellOnline &&
								productData.lowestPrice &&
								props.tabKey != 'auditPending' &&
								props.tabKey != 'approvalPending' &&
								props.tabKey != 'rejected' &&
								parseFloat(productData.sellingPrice) > parseFloat(productData.lowestPrice.toString()?.replaceAll(',',''))  ?
								<div
									// onClick={event => {
									// 	event.stopPropagation();
									// }}
									// onMouseDown={event => event.stopPropagation()}
								>
									<Button
										className={styles['lowest-price-holder']}
										size="sm"
										variant='text'
										// clickHandler={() => { showLowestPriceModal(true) }}
									>
										<div className="price-container">
											<span className="icon-refresh"></span>
											<span className="lowest-price-title">Match Lowest Competitor Price:
												<span className={`${styles['currency']} icon-currency`}></span>
												{productData.lowestPrice}
											</span>
										</div>
									</Button>
								</div>
								:
								''
							}
							{!props.isFromActionCard && conflicTab ?
								<div className="conflict-detail-holder">
									<div className="barcode-info font-12 mgb-5">
										<span>Barcode: </span><span>{productData.barcode}</span>
									</div>
									<div className="barcode-info font-12 mgb-8">
										<span>Suggested Product Counts: </span><span>{productData.suggestedProductCount}</span>
									</div>
									<div className="select-conflict-prod">
										<Button
											children='Select Product from Library'
											variant='default'
											onClick={()=>selectFromLibrary()}
										/>
									</div>
								</div>
								:
								null
							}
								{!props.isFromActionCard && productData.minOrderQuantity && productData.minOrderQuantity > 1 && !productData.isSellOnline && productData.type == 'product' ? (
									<p className={styles['prod-min-qty']}>
										Min. Qty:
										{' '}
										<span className={styles['black-color']}>
											{getUom(productData.uom, '', true) == 'PACKED' ? Math.floor(productData.minOrderQuantity) : productData.minOrderQuantity}{' '}
											{getUom(productData.uom)}
										</span>
									</p>
								) : null}
								{!props.isFromActionCard && ((props.tabKey != 'brand' && props.searchTab != 'brand')|| props.fromSelectProductSlider) && !conflicTab && (productData.isSellOnline || !productData.visibility) ? <>
									{((productData.isSellOnline) || (!productData.variant_flag && productData.hiddenVariantCount && !productData.visibility && !isAddProduct) || (productData.variant_flag && productData.hiddenVariantCount && !isAddProduct)) ? 
									<>
										<div className={`${styles['hidden-sellonline-icons']} ${productData.hiddenVariantCount ? 'hidden-variant-holder' : ''}`}>
											{productData.isSellOnline &&
												<span className={styles['sell-online-holder']}>
													<i className={`icon-newcart ${styles['new-cart-icon']}`}></i> <span>Sell Online</span>
												</span>
											}
											{!productData.variant_flag && productData.hiddenVariantCount && !productData.visibility && !isAddProduct ?
												<span className={`${styles['sell-online-holder']} ${styles['hidden-icon']}`}>
													<i className={`icon-glhide ${styles['new-cart-icon']}`} /> HIDDEN
												</span>:null
											}
											{productData.variant_flag && productData.hiddenVariantCount && !isAddProduct ?
												<span className={`${styles['sell-online-holder']} ${styles['hidden-variant-icon']}`}>
													<i className={`icon-glhide ${styles['new-cart-icon']}`} />
													{`${productData.variantCount == productData.hiddenVariantCount ? "ALL" : productData.hiddenVariantCount} VARIANT${productData.hiddenVariantCount > 1 || productData.hiddenVariantCount == productData.variantCount ? 's':''} HIDDEN`}
												</span>
												: null
											}
										</div>
									</> : null}
									{productData.quantity > 0 || productData.type == 'service' ?
									<>
									{
										(productData.type != 'service' || productData.variantCount>1 ) ?
										<div className={`${styles['instock-text']}`}>
											{productData.type != 'service' ? <>In Stock Qty: <span className={`${styles['quantity-text']}`}>{Number(productData.quantity)}</span></>: null}
											{productData.variantCount>1?
											<>
												<i className={styles['circle-dot']} />
												Variants: <span className={`${styles['quantity-text']}`}>{Number(productData.variantCount)}</span>
											</>:null}
										</div>: null
									}
									</>
										 : !isAddProduct && productData.type != 'service' && productData.isSellOnline && props.searchTab != 'brand' ?
										<div className={`${styles['outstock-holder']}`}>
											<i className={`icon-alertNew ${styles['new-alert-icon']}`}></i> Out Of Stock
										</div> : null
									}
								</> : null
								}
								{
									((props.isFromActionCard && 
										(props.slidertype == 'scoreLessThanHundred' || props.actionCardFilterType == 'scoreLessThanHundred')) || !props.isFromActionCard) && isShowProductScore && !props.session.viaOmni ? (
										<AuthWrapper>
											<ProductScore
												productId={productData.productId}
												finalWeight={props.isAuditor ? productData.productScore : productData.finalWeight}
												isBranded={productData.isTemplate}
												priceObj={allPriceObj}
												isPopUpOpenFunc={isPopUpOpenFunc}
												isServiceScore={productData.type == "service"}
											/>
										</AuthWrapper>
									) : null
								}
								{(productData.auditStatusFlag && props.isSpecialContract) ? (
									<div className={styles['audit-status-holder'] + ' ' + (!isObjection ? '' : 'no-min-order')}>
										<div className={`${styles['audit-status-icon']} ${auditStatusTag} ${auditStatusIcon}`}></div>
										<div className={`${styles['audit-status-text']} ${auditStatusTag}`}>{auditStatusText}</div>
									</div>
								) : null}
								{
									(props.tabKey != 'brand' && ((productData.queueType && props.isSpecialContract) || (brandedTab && !productData.active) || (productData.maskedTag && productData.maskedTag == "MASKED" && props.isAuditor))) ? <>
										<div className={styles['tag-holder']}>
											{((productData.queueType && props.isSpecialContract) || (brandedTab && !productData.active)) ? <div className={styles['tag-text'] + " MR5 " + tagColor}>{productTag}</div> : null}
											{(productData.maskedTag && productData.maskedTag == "MASKED" && props.isAuditor) ? <div className={styles['tag-text'] + " grey"}>{"MASKED"}</div> : null}
										</div>
									</> : null
								}
								{
									props.isFromActionCard && (props.slidertype !== '' && props.slidertype !== "imgMissingCoun" || props.actionCardFilterType !== '' && props.actionCardFilterType !== "imgMissingCoun") ?
									<Button variant="default" className={`${styles["action-card-icon"]} ${props.deviceData.isMobile ? styles["mobileClass"]:""} ${(productData.productName.length > 25 && (props.slidertype == 'scoreLessThanHundred' || props.actionCardFilterType == "scoreLessThanHundred") && isShowProductScore) ? "" : styles["stick-bottom"]}`}>
										{getBtnLabel(props?.slidertype || props?.actionCardFilterType)}
									</Button>
									: null
								}
								{props.isAuditor ? (<div className={styles['audit-button-holder']}>
									<Button
										className={styles['audit-button']}
										size="sm"
										block
										clickHandler={() => { }}
									>
										{`${isCorrector ? 'CORRECT' : 'AUDIT'}`} 
									</Button>
								</div>) : null}
								{!props.isFromActionCard && brandedTab ? (<div className={styles['suggest-button-holder']}>
									<Button
										className={styles['suggest-btn']}
										variant={'default'}
										block
										clickHandler={(e) => {
											checkLoggedIn({
												cb: () => {
													openAddEditSlider(productData.productId);
												}
											})
											e.stopPropagation();
											console.log('Add to Catelog');
										}}
									>
										<i className={'icon-plus'} />
										<div className={'btn-txt'}>{'ADD TO CATALOGUE'}</div>
									</Button>
								</div>):null}
								{!props.isFromActionCard && props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER' && !props.fromSelectProductSlider && props.pageType != 'search' && !productData.ownerEdit && objectionalTab && !viaOmni ? (
									<div className={styles['take-live-button-holder']}>
										<Button
											className={styles['take-live-button']}
											size="sm"
											block
											clickHandler={(event) => {
												event.stopPropagation();
												props.objectionableTakeLive(productData.id, {
													cb: () => {
														props.toggleRequestTakeLive && props.toggleRequestTakeLive(true);
													}
												})
											}}
										>
											Request to Take Live
										</Button>
									</div>
								) : null}
								{showCatSelectionPending ?
									<div className='cat-sel-warning'>
										<i className='icon-alertNew'></i>
										<div className='cat-sel-warning'>{productData.suggestedCategoryName ? 'Category Approval Pending' : 'Category Selection Pending'}</div>
									</div>
									: null
								}
								{!props.isFromActionCard &&
								<>
								{(productData.reviewStatus == 'APPROVAL_PENDING' || productData.reviewStatus == 'APPROVED' || productData.reviewStatus == 'DELETION_PENDING' || productData.reviewStatus == 'AUDIT_PENDING' || productData.reviewStatus?.toString().split(',').includes('REJECTED') || productData.reviewStatus?.toString().split(',').includes('DOCUMENT_PENDING') || editedByJdEmp) && !props.isAuditor && !isReadOnlyProduct && !objectionalTab && !brandedTab ? (
									<>
										{(productData.reviewStatus == 'APPROVAL_PENDING' ||
											editedByJdEmp) &&
										!showCatSelectionPending ? (
											<ProductStatus statusKey={productData.reviewStatus} />
										) : null}

										{
											(()=>{
												if(productData.reviewStatus == 'AUDIT_PENDING' || productData.reviewStatus=="APPROVED"){
													if(productData?.batchStatus && ["INVENTORY_AUDIT_PENDING","AWAITING_INVENTORY_COMPLIANCE"].includes(productData?.batchStatus)){
														return <ProductStatus statusKey={productData?.batchStatus} addExtraClass={true}/>
													}
													else if(productData.reviewStatus == 'AUDIT_PENDING'){
														return <ProductStatus statusKey={productData.reviewStatus} />
													}
												}
											})()
										}
										{productData.reviewStatus == 'DELETION_PENDING' &&
										!editedByJdEmp ? (
											<ProductStatus
												statusKey={productData.reviewStatus}
												addExtraClass={true}
											/>
										) : null}
										{(productData.reviewStatus?.toString().split(',').includes('DOCUMENT_PENDING') && (props.tabKey=='documentPending' || !props.tabKey || props.searchText)) &&
										 (
											<ProductStatus
												statusKey={'DOCUMENT_PENDING'}
												addExtraClass={true}
											/>
										)}
										{
											(props.isFromActionCard && props.slidertype == 'scoreLessThanHundred' || !props.isFromActionCard) &&  productData.reviewStatus?.toString().split(",").includes("REJECTED") &&
											(props.tabKey == "rejected" || !props.tabKey) ? (
												productData.type == "service" ? (
													<ProductStatus statusKey="SERVICE_REJECTED" addExtraClass={true} />
												) : (
													<ProductStatus statusKey="PRODUCT_REJECTED" addExtraClass={true} />
												)
											) : null
										}
										{props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER' && productData.reviewStatus != 'AUDIT_PENDING' && productData.reviewStatus != 'APPROVED' && (!productData.reviewStatus?.toString().split(',').includes('REJECTED') && !productData.reviewStatus?.toString().split(',').includes('DOCUMENT_PENDING')) ? (
											<>
												{productData.reviewStatus == 'APPROVAL_PENDING' ? (
													<div
														onClick={event => {
															event.stopPropagation();
														}}
														onMouseDown={event => event.stopPropagation()}
													>
														<Button
															className={styles['single-approve-btn']}
															size="sm"
															clickHandler={(e) => { checkForCommission(e) }}
															showLoader={showApproveProductButtonLoader}
														>
															<i className="icon-checkmarkCircle"></i>
															<div className={styles['single-btn-label']}>Approve {productData.type == 'service' ? "Service" : "Product"}</div>
														</Button>
													</div>
												) : (
													<div
														className={styles['single-delete-btn-holder']}
														onClick={event => {
															event.stopPropagation();
														}}
														onMouseDown={event =>
															event.stopPropagation()
														}>
														<Button
															className={styles['single-delete-btn']}
															clickHandler={(e) => { deleteSingleProduct(e, true) }}
															size="sm"
														>
															<i className="icon-trash"></i>
															<div className={styles['single-btn-label']}>DELETE</div>
														</Button>
														<Button
															className={styles['delete-btn-text']}
															variant="text"
															size="sm"
															clickHandler={(e) => { deleteSingleProduct(e, false) }}
														>
															DON'T DELETE
														</Button>
													</div>
												)}
											</>
										) : null}
									</>
								) : null}
								</>
								}
							</>) : null}
						</div>
						{( isAddProduct || isReadOnlyProduct || (props.isAuditor && !props.isSpecialContract) || props.tabKey == 'brand') || conflicTab ? null : (
							(!props.isFromActionCard && <div className='action-holder'>
								<div
									className={styles['more-menu-parent']}
									onClick={event => {
										event.stopPropagation();
									}}
									onMouseDown={event => event.stopPropagation()}
								>
									{props.deviceData.isMobile ? 
									<>
										{ modalOpen ? 
											<SwipeableDrawer 
												hideCross={true}
												horizontalBar={true}
												title={null}
												drawerOptions={list.map(cur => {return {...cur,text: cur.label,icon: cur.icon}})}
												onHidden={() => setModal(false)}
												className={`${styles['more-select-options']} 
													${(props.session?.isJdBusinessIOS && parseFloat(props.session?.appVersion) >= 3.3) ? 'ublc-spacing': ''}
												`}
												onClick={(e,option) => {
													setTimeout(() => {
														option.onClick();
														setModal(false);
													},200);
												}}
											/>
										: null}
										<div
											className={styles['dummy-holder']}
											onClick={() => setModal(true)}
											tabIndex={0}
											role="button"
											aria-label="More options"
											aria-haspopup="dialog"
											aria-expanded={modalOpen}
											onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); e.preventDefault(); setModal(true); } }}
										>
											<i className='icon-HDRmore' />
										</div>
									</>
										:
									<MoreMenu
										parentClass={styles['more-menu-holder']}
										menuClass={styles['more-menu']}
										list={list}
										onToggle={openEditModal}
									/>}
								</div>
							</div>)
						)}
					</>
				)}
				{modalOpen && (
					<div
						className={styles['more-menu-overlay']}
						onClick={event => {
							openEditModal(false);
							event.stopPropagation();
						}}
						onMouseDown={event => event.stopPropagation()}
					/>
				)}
				<div className='fake-border' />
			</div>
			{lowestPriceModal?
				<LowestPriceModal
					onHidden={handleCloseModal}
					title={'Match Lowest Competitor Price'}
					content={<>This will match your selling price to lowest competitor price. Are you sure you want to update selling price for <span class="lowest-prod-name">{productData.productName}</span>?</>}
					btnName= {'Update'}
					variant={'primary'}
					onclick={onConfirmDelete}
				/>
				: null
			}
			{commissionModal && <CommissionModal
				onHidden={() => showCommissionModal(false)}
				onSave={(e) => {
					approveSingleProduct(e);
					window.history.back();
				}}
				fromListing={true}
				commissionRate={productData.commissionPerc}
			/>}
			{bifurcateModel &&
				<BifurcateModel
					choosedType={(prod) => {
						showBifurcateModel(false);
						props.setSelectedType({ selectedCategoryType: prod });
						productOnclick(prod, 'bifurcate')
					}}
					showBifurcateModel={() => showBifurcateModel(false)}
				/>
			}
		</>
	);
};

const MEDIA_MAX_LIMIT = 41;
const maxImagesWhenExpanded = {
	web: {
		search: 4
	},
	mobile: {}
}
const ProductRowImageList = (props) => {
	const mediaUrlArr = [...props.mediaUrlArr]
	const isMobile = props.deviceData.isMobile;
	const dimensionsObj = isMobile ? {
		left: 15.625,
		margin: 12.5,
		minLeft: 5.5,
		unit: 'vw'
	} : {
		left: 55,
		margin: 45,
		minLeft: 18,
		unit: 'px'
	}
	if (!mediaUrlArr.length) {
		return null;
	}
	const isReadOnlyProduct = props.readOnlyProduct || props.session.isReadOnly;
	let stackOnLeft, leftMarkup = [], hideVidCam = (isReadOnlyProduct) || (props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER') && (props.productData.reviewStatus == 'APPROVAL_PENDING' || props.productData.reviewStatus == 'DELETION_PENDING');
	const maxLimitReached = mediaUrlArr.length === MEDIA_MAX_LIMIT;
	const expanded = useMemo(() => {
		// case in which only 3 media is there of which one is video
		// then in that case it will always be expanded
		return props.expanded || props.mediaUrlArr.length === 3 && props.videoUrlIds && props.videoUrlIds.length === 1 
	}, [props.expanded, props.videoUrlIds, props.mediaUrlArr])
	const [animte, toggleAnimation] = useState(expanded);
	useEffect(() => {
		if (expanded && !animte) {
			setTimeout(() => {
				toggleAnimation(true);
			});
		} else if (!expanded && animte) {
			setTimeout(() => {
				toggleAnimation(false);
			});
		}
	}, [expanded]);
	let markup = [];
	let addImageDivMarkup = [];
	let rowMaxImagesExpanded = maxImagesWhenExpanded[isMobile ? 'mobile' : 'web'][props.pageType] || 6;
	let noOfImagesVissible = expanded
		? Math.min(rowMaxImagesExpanded, mediaUrlArr.length)
		: Math.min(2, mediaUrlArr.length);
	if (maxLimitReached && expanded) {
		noOfImagesVissible += 1;
	}
	stackOnLeft = hideVidCam && noOfImagesVissible > 3;
	const noOfStackedImages = expanded ? 0 : Math.min(1, mediaUrlArr.length - 1);
	let remImages = Math.max(mediaUrlArr.length - noOfImagesVissible + noOfStackedImages, 0);
	if (remImages === 1 && !expanded) {
		remImages = 0;
	} else if (remImages && expanded) {
		remImages += 1;
	}
	let addImageDivCount = getAddImageDivCount({
		images: props?.imageUrlArr?.length,
		videos: props?.videoUrlIds ? props?.videoUrlIds?.length : 0,
		isSourceB2B: true
	});
	let showAddVideoDiv = props.videoUrlIds && !props.videoUrlIds.length && !props.showUpload;
	if (props.noPrimaryImage) {
		addImageDivCount--;
	}
	if (showAddVideoDiv && expanded && noOfImagesVissible >= 6) {
		if (addImageDivCount) {
			noOfImagesVissible--;
			if (!remImages) {
				remImages++;
			}
			remImages++;
			//if no remImages then remImages will be 2
		}
	}
	if (stackOnLeft && remImages > 0) {
		remImages--;
	}
	for (let index = 1; index <= noOfImagesVissible; index++) {
		const addProps =
			index === (!expanded ? (stackOnLeft ? 2 : 1) : noOfImagesVissible - 1)
				? {
					remainingImages: remImages
				}
				: null;
		const animateProps = {
			isExpanded: expanded,
			animateExpOnClick: show => {
				if (show) {
					props.toggleExpanded(props.productId);
				}
			}
		};
		if (index === noOfImagesVissible) {
			const noimages = markup && markup.length === 0;
			let left = noimages ? 0 : Math.max((noOfImagesVissible - 1) * dimensionsObj.minLeft, dimensionsObj.left);
			if (animte) {
				left = (noOfImagesVissible - 1) * dimensionsObj.left;
			}
			if (!props.isTemplate && !hideVidCam && !props.isDummyProductRow ) {
				[...Array(addImageDivCount)].forEach((_, addIndex) => {
					if(props.imageUrlArr.length <= 1){
						addImageDivMarkup.push(
							<Image
								{...props}
								isImageList
								onlyForSelection={(props.session.newProfile == '1' && props.creCheck.source === "14" && props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE')}
								imageListIndex={props.imageUrlArr.length + addIndex}
								{...addProps}
								redirectToEdit={props.redirectToEdit}
								isAddImageDiv={true}
								style={{
									left: `${left * (addIndex + 1)}${dimensionsObj.unit}`
								}}
								pos='bottom'
							/>
						);
					}
				})
				if (showAddVideoDiv) {
					let styleLeft = 0;
					if (left) {
						styleLeft = `calc(${left + dimensionsObj.margin * (addImageDivMarkup.length)}${dimensionsObj.unit} + ${(addImageDivMarkup.length) * 12}px)`;
						styleLeft = !noimages ? styleLeft.replace(')',' - 5px)') : styleLeft;
					}
					addImageDivMarkup.push(
						<AddVideoDiv
							{...props}
							{...addProps}
							isAddImageDiv={true}
							style={{
								left: styleLeft
							}}
							pos='bottom'
						/>
					)
				}
			}
		} else if (stackOnLeft && index == 1) {
			leftMarkup.push(
				<Image
					{...props}
					imageUrlArr={mediaUrlArr}
					imageListIndex={index}
					redirectToEdit={props.redirectToEdit}
					onlyForSelection={expanded || (props.session.newProfile == '1' && props.creCheck.source === "14" && props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE')}
					// {...animateProps}
					pos='bottom'
				/>
			)
		} else {
			markup.push(
				<Image
					{...props}
					imageUrlArr={mediaUrlArr}
					imageListIndex={index}
					redirectToEdit={props.redirectToEdit}
					className={(mediaUrlArr.length > 2 && (props?.productData?.imageUrlArr?.length != 2) && mediaUrlArr.length - 1  != index) ? 'roundimageafter' : ''}
					onlyForSelection={expanded || (props.session.newProfile == '1' && props.creCheck.source === "14" && props.session.user.loggedUser && props.session.user.loggedUser.userType == 'JDEMPLOYEE')}
					{...addProps}
					// {...animateProps}
					pos='bottom'
				/>
			);
		}
	}
	const noimages = markup && markup.length === 0;

	markup = (!props.isFromActionCard && !props.isDummyProductRow&&
		<div
			className={`row-imagelist-wrapper ${leftMarkup.length > 0 ? 'stack-on-left ' : ''} ${(noimages) ? 'empty' : ''} ${isReadOnlyProduct ? 'read-only-row' : ''}`}
			onClick={e => e.stopPropagation()}
		>
			{!noimages && (
				<>
					{leftMarkup.length > 0 ? leftMarkup : null}
					<div className={`list-animate ${animte ? 'expanded' : 'stacked'} `}>
						{markup}
					</div>
				</>
			)}
			{!maxLimitReached && addImageDivMarkup}
		</div>
	);
	return markup;
}

const RemainingImagesPatch = (props) => {
	return (
		<div>
			{props.text}
		</div>
	)
}

const mapStateToProps = (state, props) => {
	const productData = state.products.allProducts[props.productId] || {};
	const isTemplateProd = (productData?.showUpload === 1 ? true : productData.isTemplate);
	productData.isTemplate =
    (productData.showUpload !== 1 &&
      productData.isTemplate &&
      !props?.isFromActionCard) ||
    (props?.isFromActionCard &&
      ((props?.slidertype !== "" && props?.slidertype !== "imgMissingCoun") ||
        (state?.products?.actionCardFilter?.type != "" &&
				!["imgMissingCoun","scoreLessThanHundred"].includes(state?.products?.actionCardFilter?.type)
			)));
	if (productData.videoUrlIds) {
		productData.videoUrlIds = productData.videoUrlIds.filter(cur => cur != '');
		productData.videoUrlArr = productData.videoUrlIds
	.filter((curId) => state.videoLibrary.videos[curId])
	.map((curId) => state.videoLibrary.videos[curId])
	} else {
		productData.videoUrlArr = [];
	}
	return {
		...props,
		productData,
		uomJsonMap: state.uom.uomJsonMap,
		tabKey: state.products.tabKey,
		isSpecialContractJd: state.products.listing.isSpecialContractJd,
		approvalPendingList: state.products.approvalPendingList,
		productConflictList: state.products.productConflictList,
		auditPendingList: state.products.auditPendingList,
		objectionalAuditPendingList: state.products.objectionalAuditPendingList,
		deletionPendingList: state.products.deletionPendingList,
		rejectedList : state.products.rejectedList,
		objectionableList: state.products.objectionableList,
		brandList: state.products.brandList,
		inventoryComplianceList: state.products.mrpcomplianceList,
		genericDeletionList: state.products.genericDeletionList,
		brandSelDesel: state.products.brandSelDesel,
		session: state.session,
		showAddEditProduct: state.products.showAddEditProduct,
		uom: state.uom.productUOM,
		deviceData: state.deviceData,
		objectionableProducts: state.products.vendorObjectionableProducts,
		showLibrarySlider: state.videoLibrary.showLibrarySlider,
		isTemplateProd: isTemplateProd,
		isActionCardSliderOpen: state.products?.isActionCardSliderOpen,
		actionCardFilterType: state.products?.actionCardFilter.type,
		searchTab: state?.products?.search?.searchTab
	};
};

export default connect(mapStateToProps, {
	toggleProductVisibility,
	showItemSearchSlider,
	deleteProduct,
	showToastMessage: toastMessageActions.showMessage,
	updateApprovalPending,
	productUnderEdit,
	updateDeletionPending,
	updateProductStatus,
	matchLowestPrice,
	getListingData,
	setRedirectedFrom,
	fetchDataAndEdit,
	getProductData,
	setSelectedType,
	setRedirectedFrom,
	objectionableTakeLive,
	updateGenericDeletionPending,
	updateBrand,
	updateEditProductDetail,
	updateAuditPending,
	updateRejectedProducts,
	toggleProdConflict,
	updateBrandManufactureDetails,
	getPsvDetails,
})(withRipple(ProductRow));
